import toast from "react-hot-toast";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export default async function fileUpload(file, entityName, fileTags) {
  const formData = new FormData();
  formData.append("entityName", entityName);
  formData.append("fileTags", fileTags);
  formData.append("files", file);
  //   Object.values(files).forEach((file) => {
  //     formData.append("files", file);
  //   });

  try {
    const response = await fetch(`${apiUrl}/api/files/fileupload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data) {
      toast.success("Upload successful.", {
        position: "bottom-center",
        style: {
          background: "blue", // override background
          color: "white",
          fontWeight: "medium",
          marginBottom: "50px",
        },
      });
      return data;
    } else {
      toast.error("Upload failed.");
      return null;
    }
  } catch (error) {
    console.error("Error uploading images:", error);
    toast.error("Upload failed.");
    return null;
  }
}
